import { render, staticRenderFns } from "./ScoreCard.vue?vue&type=template&id=31883972&scoped=true&"
import script from "./ScoreCard.vue?vue&type=script&lang=js&"
export * from "./ScoreCard.vue?vue&type=script&lang=js&"
import style0 from "./ScoreCard.vue?vue&type=style&index=0&id=31883972&prod&scoped=true&lang=css&"
import style1 from "./ScoreCard.vue?vue&type=style&index=1&id=31883972&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31883972",
  null
  
)

export default component.exports